<input
  #input
  [type]="type"
  [disabled]="disabled"
  [attr.readOnly]="readOnly ? '' : null"
  [placeholder]="placeholder || ''"
  [attr.maxlength]="maxLength"
  [attr.tabindex]="tabIndex"
  [style.width]="width"
  (input)="handleChange($any($event.target).value)"
  (focus)="focus.emit($event)"
  (blur)="blur.emit($event)"
  text-primary
/>
<rt-icon *ngIf="icon" [name]="icon" (click)="iconClick.emit()"></rt-icon>
<ng-content select="rt-icon"></ng-content>
<div
  *ngIf="dropdown"
  [class.has-margin]="dropdownIconHasMargin"
  (click)="setFocus()"
  class="icon-dropdown"
>
  <div class="arrow-dropdown"></div>
</div>

<div *ngIf="loading" class="input-spinner">
  <rt-spinner variant="small"></rt-spinner>
</div>

<rt-icon-button
  *ngIf="isRemoveButtonVisible()"
  #clearButton
  (click)="onRemoveButtonCLick()"
  variant="plain"
  iconName="close"
  shape="square"
  class="clear-search"
  size="small"
></rt-icon-button>
